import * as AccountRecovery from '../services/api/requests/AccountRecovery'

// import { setGAEvent } from '../services/analytics/google-analytics'

import {
  OTP,
  UPDATE,
  VERIFY_UPDATE,
} from '../services/data/accountRecoverySteps.json'

import { UPDATE_PROFILE } from '../services/data/profilePages.json'

import {
  encodeSSOData,
  saveSSOData,
  isClientVerified,
  deleteSSOVerification,
  getRedirectUri,
} from '../services/data/sso.js'
import { doHandleSSORedirection } from './Login'

// export const doHandleSSORedirection = async (
//   searchString,
//   redirectToThirdParty,
//   code,
//   nativeRedirect,
// ) => {
//   if (searchString && redirectToThirdParty && code) {
//     const redirectUri = await getRedirectUri(searchString)
//     const responseType = await getResponseType(searchString)
//     const thisCode = responseType === 'code' ? code : undefined
//     await redirectToThirdParty(redirectUri, thisCode)
//   } else nativeRedirect && (await nativeRedirect())
// }

export const doRequestAccountRecovery = ({
  setRecoveryRequestId,
  setMaskedData,
  setRecoveryStep,
  replace,
  searchString,
}) => async (values, state) => {
  state.setSubmitting(true)
  const { accountIdentifier } = values

  try {
    const maskedEmail = accountIdentifier
    // .split('@')
    // .map(str => str.replace(/(?<!^).(?!$)/g, '*'))
    // .join('@')
    const recoveryResponse = await AccountRecovery.postRequestRecovery({
      email: accountIdentifier,
    })

    const { requestId } = recoveryResponse.data

    setMaskedData({ email: accountIdentifier, maskedEmail })
    setRecoveryRequestId(requestId)
    await setRecoveryStep(OTP)

    replace(`/account-recovery/otp${searchString || ''}`)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }

  state.setSubmitting(false)
}

export const doResendOtpRecoveryRequest = ({
  setRecoveryRequestId,
  email,
}) => async (values, state) => {
  state.setSubmitting(true)

  try {
    const recoveryResponse = await AccountRecovery.postRequestRecovery({
      email,
    })

    const { requestId } = recoveryResponse.data

    setRecoveryRequestId(requestId)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }

  state.setSubmitting(false)
}

export const doVerifyOtp = ({
  setRecoveryRequestId,
  recoveryRequestId,
  setPrimaryInfo,
  setRecoveryStep,
  replace,
  setProfileModalPage,
  displayProfileModal,
  searchString,
}) => async (values, state) => {
  state.setSubmitting(true)

  state.setStatus({
    error: '',
  })
  try {
    const { code } = values
    const otpResponse = await AccountRecovery.postVerifyOtpRecovery({
      code,
      requestId: recoveryRequestId,
    })
    const { user, requestId } = otpResponse.data

    setPrimaryInfo({ ...user, mobileNumber: '' })
    setRecoveryRequestId(requestId)

    await setRecoveryStep(UPDATE)

    // TODO: add if for redirect URI -> handle Redirect to SSO
    replace(`/${searchString || ''}`)

    displayProfileModal(true)
    setProfileModalPage(UPDATE_PROFILE)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: 'There was an error processing your request',
    })

    if (message.toLowerCase().indexOf('otp') >= 0) {
      state.setFieldError('code', message)
      // state.setFieldError('code', 'Invalid OTP')
      state.setStatus({})
    }
  }
  state.setSubmitting(false)
}

export const doUpdateMobile = ({
  setRecoveryRequestId,
  setRecoveryStep,
  recoveryRequestId,
  callback,
}) => async (values, state) => {
  state.setSubmitting(true)

  try {
    const { mobileNumber: mobile } = values
    const updateResponse = await AccountRecovery.postUpdateMobileRecovery({
      requestId: recoveryRequestId,
      mobile,
    })

    const { requestId } = updateResponse.data
    setRecoveryRequestId(requestId)

    setRecoveryStep(VERIFY_UPDATE)

    callback && callback()
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

export const doVerifyUpdateMobile = ({
  setPrimaryInfo,
  setAccessToken,
  setRecoveryRequestId,
  recoveryRequestId,
  firebaseMessagingToken,
  setRecoveryStep,
  setProfileModalPage,
  displayProfileModal,
  doSubscribeToFirebaseMessaging,
  callback,
  saveAccessToken,
  redirectToThirdParty,
  searchString,
}) => async (values, state) => {
  state.setSubmitting(true)

  if (searchString && !isClientVerified()) {
    state.setStatus({
      error: 'Client not verified.',
    })

    return
  }
  try {
    const { code } = values
    const otpResponse = await AccountRecovery.postVerifyUpdateMobileOtp(
      {
        requestId: recoveryRequestId,
        code,
      },
      firebaseMessagingToken,
    )

    const {
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
      user,
    } = otpResponse.data
    const token = encodeSSOData({
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
    })

    if (saveAccessToken) await saveAccessToken(accessToken)
    if (saveSSOData) await saveSSOData(token)
    if (firebaseMessagingToken)
      await doSubscribeToFirebaseMessaging({
        firebaseMessagingToken,
      })()

    if (searchString && getRedirectUri(searchString)) {
      await deleteSSOVerification()
      await doHandleSSORedirection(
        searchString,
        redirectToThirdParty,
        accessToken,
        // customRedirect,
      )
    } else {
      setAccessToken(accessToken)
      setPrimaryInfo(user)
      setRecoveryRequestId(null)
      setRecoveryStep(0)
      displayProfileModal(false)
      setProfileModalPage(0)
      state.setSubmitting(false)
    }

    // setGAEvent('sign_up', 'sign_up', 'native_registration')
  } catch (error) {
    const { data = {} } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      error: 'There was an error processing your request',
    })

    if (message.toLowerCase().indexOf('otp') >= 0) {
      state.setFieldError('code', 'Invalid OTP')
      state.setStatus({})
    }
  }
  state.setSubmitting(false)
}

export const doResendUpdateMobile = ({
  setRecoveryRequestId,
  recoveryRequestId,
  callback,
}) => async (values, state) => {
  state.setSubmitting(true)

  try {
    const updateResponse = await AccountRecovery.resendUpdateMobile({
      requestId: recoveryRequestId,
    })
    const { requestId } = updateResponse.data

    setRecoveryRequestId(requestId)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}
